export default {
  estimations: [],
  estimation: undefined,
};
